module.exports = __webpack_public_path__ + "8241e4d139cf678854015894baba9ac9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/smilies/1.png
// module id = 3621
// module chunks = 0